module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-container-single element-non-bodymatter element-type-blurbs element-with-heading",
    attrs: {
      "id": "praise-for-graham-smith"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image",
    attrs: {
      "id": "praise-for-graham-smith-heading"
    }
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-without-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Praise for Graham Smith")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "praise-for-graham-smith-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_vm._v("\"This is one hell of a rollercoaster that just kept me glued to my kindle, but it was a roller coaster I didn’t want to end.\" "), _c('b', [_c('i', [_vm._v("Claire Knight - A Knight's Reads")])])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("\"The story itself was very entertaining and kept me gripped throughout the entire book. It seems that Graham Smith has a knack of really capturing the story and ensuring it’s pleasing to the reader.\" "), _c('b', [_c('i', [_vm._v("Sean Talbot - Seans Book Reviews")])])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("\"Graham Smith has a talent for writing characters that are so personable and I do wonder if my emotions can handle much more! A fantastic addition to the Jake Boulder series; five stars from me.\" "), _c('b', [_c('i', [_vm._v("Ellen Devonport - Bibliophile Book Club")])])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('b', [_c('i', [_vm._v("\"")])]), _vm._v("Past Echoes is an excellent title for this extremely exciting book that is full of gameplay...\" "), _c('b', [_c('i', [_vm._v("Alexina Golding – Bookstormer")])])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("\"Another book I could talk about forever…I cannot tell you all the WOW, OMFG and WTAF moments because this is one book you NEED to read for yourself.\" "), _c('b', [_c('i', [_vm._v("Noelle Holten – CrimeBookJunkie")])])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("\"I find Graham Smith’s writing to be unique like the work of Karin Slaughter. His prose is completely purposeful and done with taste...\" "), _c('b', [_c('i', [_vm._v("Samantha Ellen - Clues and Reviews")])])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("\"This is another fantastic cat and mouse thriller. I haven’t been disappointed yet by Smith and his writing – you’re on the edge of your seat for the majority of the book.\" "), _c('b', [_c('i', [_vm._v("Jessica Robins - Jessicamap Reviews")])])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("\"Past Echoes gives you thrilling, psychological drama at it’s best with Jake Boulder, meaner and tougher than ever before.\" "), _c('b', [_c('i', [_vm._v("Sharon Bairden - Chapter In My Life")])])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('b', [_c('i', [_vm._v("\"")])]), _vm._v("There were a lot of “OMG!” moments in this book, and I can’t wait to see what Mr Smith has planned for Jake in the next instalment.\" "), _c('b', [_c('i', [_vm._v("Danielle Ryan - The Blonde Likes Books")])])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("\"Raw, evocative and deliciously intense. I loved it!\" "), _c('b', [_c('i', [_vm._v("Emma Welton – damppebbles")])])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("\"If it’s possible, the Jake Boulder series is getting even better. This book just grabbed me and didn’t let go until the very end...\" "), _c('b', [_c('i', [_vm._v("Ashley Gillan - (e)Book Nerd Reviews")])])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("\"Great characters, a fast-paced narrative and an addictive storyline all add up to make this thriller a must read!\" "), _c('b', [_c('i', [_vm._v("Joanne Robertson")])]), _vm._v(" - "), _c('b', [_c('i', [_vm._v("My Chestnut Reading Tree")])])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("\"Smith excels in scenes where Boulder has to face down his adversaries. There's plenty of smart dialogue and great action.\" "), _c('b', [_c('i', [_vm._v("Colman Keane - Col's Criminal Library")])])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("\"I thoroughly enjoyed this book, it was one of those books that you want to read in one sitting, it is fast-paced and full of action!\" "), _c('b', [_c('i', [_vm._v("Donna Maguire - Donnas Book Blog")])])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("\"I have loved each and every one of these books, I love Graham's style of writing, the knack he has to get the reader involved in the story is first class.\" "), _c('b', [_c('i', [_vm._v("Vicki Wilkinson - ILoveReadingUK")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7099ad7a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/praise-for-graham-smith.vue
// module id = 75
// module chunks = 0